import CustomText from "../atomic/CustomText";
import { formatPhoneForDisplay } from "../../utils/helpers/phoneNumberHelpers";

interface ProfilePhoneRowProps {
  phone?: string | null;
  verified?: boolean;
  onEdit: () => void;
  className?: string;
}

function ProfilePhoneRow({
  phone,
  verified = false,
  onEdit,
  className,
}: Readonly<ProfilePhoneRowProps>): JSX.Element {
  const hasPhone = !!phone && phone.replace(/\D/g, "").length > 0;
  const display = hasPhone ? formatPhoneForDisplay(phone) : "";
  const actionLabel = !hasPhone ? "Add phone" : verified ? "Edit" : "Verify";

  return (
    <div className={`my-3 w-full ${className || ""}`}>
      <CustomText
        text="Phone"
        className="inputLabel"
        fontWeight="font-semibold"
      />
      {/* Input stays full form width (same as First Name / Email); action sits outside to the right. */}
      <div className="relative w-full">
        <input
          type="text"
          disabled
          readOnly
          value={
            display
              ? `${display}${verified ? " (Verified)" : " (Unverified)"}`
              : ""
          }
          placeholder="No phone number"
          className="roundedTextInput cursor-not-allowed text-royalBlue text-xs sm:text-base font-sans w-full"
          aria-label="Phone number"
        />
        <button
          type="button"
          onClick={onEdit}
          className="absolute left-full top-1/2 -translate-y-1/2 ml-3 text-sm text-primary font-semibold whitespace-nowrap hover:text-primaryHover cursor-pointer"
        >
          {actionLabel}
        </button>
      </div>
    </div>
  );
}

export default ProfilePhoneRow;
